import baseAPI from './baseAPI';

export const applyJob = async (formData) => {
  const resp = await baseAPI.formPost('/pulse/job/apply', formData);
  if (!resp.ok) {
    throw new Error('Failed to apply for job');
  }
  return await resp.json();
};
